import { Alert } from '@havenengineering/module-shared-owners-ui/dist/v2/components/Alert';
import useSWRImmutable from 'swr/immutable';

import { swrLocalFetcher } from '../../helpers/fetch';

export const AlertBanner = () => {
  const { data: alertBannerContent } = useSWRImmutable<string>(
    `/contentful/alert-banner`,
    swrLocalFetcher
  );

  if (!alertBannerContent) return null;

  return <Alert title="Notice:" text={alertBannerContent} severity="info" />;
};
